import { TelemetryInitializerFunc } from './models';
import { tagTelemetryInitializer } from './tag-telemetry-initializer';

export const appVersionTelemetryInitializer = (version: string): TelemetryInitializerFunc =>
  tagTelemetryInitializer('ai.application.ver', version);
